export default "__VITE_ASSET__UIdJHA4p__";